import {
  checkToDisplayValueInK,
  checkToDisplayValueInCr,
  checkToDisplayValueInL,
  parseDecimalValuesOfNumber,
} from "@/Common/utils/GameUtils";
import React from "react";
import CountdownTimer from "../Common/CountdownTimer";
import {
  TOURNEY_STATUS_LIVE,
  TOURNEY_STATUS_COMPLETED,
} from "@/Poker/data/Constants";

function TourneyDetailsBlindStructure({ selectedTourneyDetails }) {
  const {
    blindStructure,
    currentLevel,
    currentLevelNumber,
    maxLevelNumber,
    nextLevel,
    nextLevelNumber,
    nextBlindLevelStartTimeInSeconds,
    nextBlindLevelEndTimeInEpochSeconds,
    reEntry,
    blindStructureEndLevel,
    levelDuration,
    tourneyIdentifier,
    tourneyStatus,
  } = selectedTourneyDetails;

  const getCurrentLevelBlind = (type) => {
    if (blindStructure?.length > 0) {
      const filteredLevel = blindStructure.filter(
        (o) => o.level == currentLevelNumber
      )[0];
      if (filteredLevel) {
        const str = `${parseDecimalValuesOfNumber(
          filteredLevel.sb,
          2,
          checkToDisplayValueInK(filteredLevel.sb),
          checkToDisplayValueInL(filteredLevel.sb),
          checkToDisplayValueInCr(filteredLevel.sb)
        )}/${parseDecimalValuesOfNumber(
          filteredLevel.bb,
          2,
          checkToDisplayValueInK(filteredLevel.bb),
          checkToDisplayValueInL(filteredLevel.bb),
          checkToDisplayValueInCr(filteredLevel.bb)
        )}(${
          parseDecimalValuesOfNumber(
            filteredLevel.ante,
            2,
            checkToDisplayValueInK(filteredLevel.ante),
            checkToDisplayValueInL(filteredLevel.ante),
            checkToDisplayValueInCr(filteredLevel.ante)
          ) || 0
        })`;
        return str;
      }
      return "";
    }
  };

  const getNextLevelBlind = () => {
    if (blindStructure?.length > 0) {
      const filteredLevel = blindStructure.filter(
        (o) => o.level == nextLevelNumber
      )[0];
      if (filteredLevel) {
        const str = `${parseDecimalValuesOfNumber(
          filteredLevel.sb,
          2,
          checkToDisplayValueInK(filteredLevel.sb),
          checkToDisplayValueInL(filteredLevel.sb),
          checkToDisplayValueInCr(filteredLevel.sb)
        )}/${parseDecimalValuesOfNumber(
          filteredLevel.bb,
          2,
          checkToDisplayValueInK(filteredLevel.bb),
          checkToDisplayValueInL(filteredLevel.bb),
          checkToDisplayValueInCr(filteredLevel.bb)
        )} Ante - (${
          parseDecimalValuesOfNumber(
            filteredLevel.ante,
            2,
            checkToDisplayValueInK(filteredLevel.ante),
            checkToDisplayValueInL(filteredLevel.ante),
            checkToDisplayValueInCr(filteredLevel.ante)
          ) || 0
        })`;
        return str;
      }
      return "";
    }
  };

  return (
    <div>
      {/* section 1 */}
      {/* display iff live */}

      {tourneyStatus === TOURNEY_STATUS_LIVE && (
        <div className="mb-4 bg-foreground text-white rounded-300 py-3.5 px-3">
          <div className={`flex items-center justify-between`}>
            <div className="text-2xs text-center font-normal text-secondary w-1/3">
              CURRENT BLIND LVL
            </div>
            <div className="text-2xs text-center font-normal text-secondary w-1/3 ">
              NEXT BLIND LVL
            </div>
            <div className="text-2xs text-center font-normal text-secondary w-1/3 ">
              BLINDS UP IN
            </div>
          </div>
          <div className={`flex items-center justify-between rounded-md  mt-1`}>
            <div className="flex items-center justify-center w-1/3">
              <div className="w-1 h-1 rounded-full bg-success mr-1" />
              <div className="text-xs text-center font-bold text-primary">
                {getCurrentLevelBlind()}
              </div>
            </div>
            <div className="text-xs text-center font-bold text-primary w-1/3 ">
              {getNextLevelBlind()}
            </div>
            <div className="text-xs text-center font-bold text-primary w-1/3 ">
              <CountdownTimer
                // startTime={1754563298765}
                // startTime={nextBlindLevelStartTimeInSeconds || 0}
                startTime={nextBlindLevelEndTimeInEpochSeconds * 1000 || 0}
                isMinutes
                isSeconds
              />
              {/* {nextBlindLevelStartTimeInSeconds}  use this as countdown timer*/}
            </div>
          </div>
        </div>
      )}

      {/* section 2 */}
      <div className="mb-6">
        {blindStructure?.length > 0 && (
          <div className="bg-foreground/60 text-white rounded-md p-4 space-y-2 mt-3">
            <div
              className={`flex items-center justify-between px-3 py-2 rounded-md `}
            >
              <div className="text-xs font-medium text-secondary w-1/7">
                Level
              </div>
              <div className="text-xs font-medium text-secondary w-4/7">
                Blind (Ante)
              </div>
              <div className="text-xs font-medium text-secondary w-2/7">
                Minutes
              </div>
            </div>
            {/* hide if completed */}
            {blindStructure.map((item, index) => (
              <div
                className={`${
                  tourneyIdentifier !== "completedTourneys" &&
                  tourneyStatus !== TOURNEY_STATUS_COMPLETED &&
                  currentLevelNumber == item.level
                    ? "border border-b-surface2 pb-1 bg-secondary/20"
                    : tourneyIdentifier !== "completedTourneys" &&
                      tourneyStatus !== TOURNEY_STATUS_COMPLETED &&
                      reEntry?.reEntrySettings?.reentryLevel == item.level
                    ? "border border-b-focus2 pb-1 bg-secondary/20"
                    : tourneyIdentifier !== "completedTourneys" &&
                      tourneyStatus !== TOURNEY_STATUS_COMPLETED &&
                      item.level == blindStructureEndLevel
                    ? "border border-secondary pb-1 bg-secondary/20"
                    : "py-1 bg-linear-to-r from-foreground/40 to-surface/10"
                } rounded-300 overflow-hidden `}
              >
                {/* hide if completed */}

                {currentLevelNumber == item.level ||
                reEntry?.reEntrySettings?.reentryLevel == item.level ||
                // item.finalLevel ? (
                item.level == blindStructureEndLevel ? (
                  <div className="flex">
                    <div
                      className={`text-2xs font-medium ${
                        currentLevelNumber == item.level
                          ? "bg-b-surface2"
                          : reEntry?.reEntrySettings?.reentryLevel == item.level
                          ? "bg-b-focus2"
                          : // : item.finalLevel
                          item.level == blindStructureEndLevel
                          ? "bg-secondary/40"
                          : ""
                      } px-2 py-0.5 rounded-br`}
                    >
                      {currentLevelNumber == item.level
                        ? "Current Level"
                        : reEntry?.reEntrySettings?.reentryLevel == item.level
                        ? "Final Level for Re-Entries"
                        : // : item.finalLevel
                        item.level == blindStructureEndLevel
                        ? "Tournament Ends"
                        : ""}
                    </div>
                  </div>
                ) : (
                  <div />
                )}
                <div
                  key={index}
                  className={`flex items-center justify-between px-3 py-2 rounded font-bold text-sm text-primary`}
                >
                  <div className="w-1/7">{item.level}</div>
                  <div className="w-4/7 ">{`${parseDecimalValuesOfNumber(
                    item.sb,
                    2,
                    checkToDisplayValueInK(item.sb),
                    checkToDisplayValueInL(item.sb),
                    checkToDisplayValueInCr(item.sb)
                  )}/${parseDecimalValuesOfNumber(
                    item.bb,
                    2,
                    checkToDisplayValueInK(item.bb),
                    checkToDisplayValueInL(item.bb),
                    checkToDisplayValueInCr(item.bb)
                  )} (${parseDecimalValuesOfNumber(
                    item.ante,
                    2,
                    checkToDisplayValueInK(item.ante),
                    checkToDisplayValueInL(item.ante),
                    checkToDisplayValueInCr(item.ante)
                  )})`}</div>
                  <div className="w-2/7">
                    {levelDuration > 0 ? levelDuration / 60 : levelDuration}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default TourneyDetailsBlindStructure;

const mockblindStructure = [
  {
    bb: 20,
    ante: 0,
    level: 1,
    sb: 10,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 40,
    ante: 0,
    level: 2,
    sb: 20,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 60,
    ante: 0,
    level: 3,
    sb: 30,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 80,
    ante: 0,
    level: 4,
    sb: 40,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 100,
    ante: 0,
    level: 5,
    sb: 50,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 120,
    ante: 0,
    level: 6,
    sb: 60,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 150,
    ante: 0,
    level: 7,
    sb: 75,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 200,
    ante: 20,
    level: 8,
    sb: 100,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 250,
    ante: 25,
    level: 9,
    sb: 125,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 300,
    ante: 30,
    level: 10,
    sb: 150,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 400,
    ante: 40,
    level: 11,
    sb: 200,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 500,
    ante: 50,
    level: 12,
    sb: 250,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 600,
    ante: 60,
    level: 13,
    sb: 300,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 800,
    ante: 80,
    level: 14,
    sb: 400,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 1000,
    ante: 100,
    level: 15,
    sb: 500,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 1200,
    ante: 120,
    level: 16,
    sb: 600,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 1400,
    ante: 140,
    level: 17,
    sb: 700,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 1600,
    ante: 160,
    level: 18,
    sb: 800,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 1800,
    ante: 180,
    level: 19,
    sb: 900,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 2000,
    ante: 200,
    level: 20,
    sb: 1000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 2500,
    ante: 250,
    level: 21,
    sb: 1250,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 2800,
    ante: 280,
    level: 22,
    sb: 1400,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 3000,
    ante: 300,
    level: 23,
    sb: 1500,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 3500,
    ante: 350,
    level: 24,
    sb: 1750,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 4000,
    ante: 400,
    level: 25,
    sb: 2000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 5000,
    ante: 500,
    level: 26,
    sb: 2500,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 6000,
    ante: 600,
    level: 27,
    sb: 3000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 7000,
    ante: 700,
    level: 28,
    sb: 3500,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 8000,
    ante: 800,
    level: 29,
    sb: 4000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 9000,
    ante: 900,
    level: 30,
    sb: 4500,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 10000,
    ante: 1000,
    level: 31,
    sb: 5000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 12000,
    ante: 1200,
    level: 32,
    sb: 6000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 14000,
    ante: 1400,
    level: 33,
    sb: 7000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 16000,
    ante: 1600,
    level: 34,
    sb: 8000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 18000,
    ante: 1800,
    level: 35,
    sb: 9000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 20000,
    ante: 2000,
    level: 36,
    sb: 10000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 25000,
    ante: 2500,
    level: 37,
    sb: 12500,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 30000,
    ante: 3000,
    level: 38,
    sb: 15000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 35000,
    ante: 3500,
    level: 39,
    sb: 17500,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 40000,
    ante: 4000,
    level: 40,
    sb: 20000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 50000,
    ante: 5000,
    level: 41,
    sb: 25000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 60000,
    ante: 6000,
    level: 42,
    sb: 30000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 70000,
    ante: 7000,
    level: 43,
    sb: 35000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 80000,
    ante: 8000,
    level: 44,
    sb: 40000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 100000,
    ante: 10000,
    level: 45,
    sb: 50000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 120000,
    ante: 12000,
    level: 46,
    sb: 60000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 150000,
    ante: 15000,
    level: 47,
    sb: 75000,
    levelDuration: 0,
    finalLevel: false,
  },
  {
    bb: 200000,
    ante: 20000,
    level: 48,
    sb: 100000,
    levelDuration: 0,
    finalLevel: false,
  },
];
